<template>
    <div
        class="d-flex pa-0 ma-0 fill-height align-self-end ga-0"
    >
        <v-btn
            color="accent-darken-1"
            to="/cart"
            rounded="0"
            variant="elevated"
            size="x-large"
            width="35%"
            flat
        >
            Cart
        </v-btn>
        <v-btn
            color="primary"
            to="/checkout"
            :disabled="!canCheckout"
            rounded="0"
            variant="elevated"
            size="x-large"
            width="65%"
            flat
        >
            Checkout
        </v-btn>
    </div>
</template>

<script lang="ts" setup>
    import { useCarts } from '~/composables';

    const { canCheckout } = useCarts();
</script>

<style lang="scss" scoped></style>
